/* @flow */
import SchoolAffiliationPending from './SchoolAffiliationPending.jsx';
import Box from 'components/Box.jsx';
import BoxBody from 'components/BoxBody.jsx';
import BoxFooter from 'components/BoxFooter.jsx';
import Link from 'components/Link.jsx';
import ModalTrigger from 'components/ModalTrigger.jsx';
import SupportDialog from 'support/components/SupportDialog.jsx';
import React from 'react';
import YouTubeEmbed from 'components/YouTubeEmbed.jsx';
import { VIDEO_URL } from 'admin/constants/AdminRoles';

import './styles/SchoolAdminPending.scss';

const ADMIN_RESOURCES = 'https://www.remind.com/resources/administrators';

const SchoolAdminPending = React.createClass({
  propTypes: {
    affiliation: React.PropTypes.object,
  },

  renderBox() {
    return (
      <Box
        size="small"
        full
        className="SchoolAdminPending-Box">
        <BoxBody divided={false} size="small">
          <div className="SchoolAdminPending-TopText">
            Meanwhile, watch an overview of Remind for Schools.
          </div>
          <YouTubeEmbed
            className="SchoolAdminPending-Video"
            width={544}
            height={306}
            src={VIDEO_URL}
          />
        </BoxBody>
        <BoxFooter>
          <div className="SchoolAdminPending-BottomText">
            You can also {' '}
            <Link href={ADMIN_RESOURCES} target="_blank">check out</Link>
            {' '}
            our administrator resources or {' '}
            <ModalTrigger modal={<SupportDialog />}>
              <Link>contact us</Link>
            </ModalTrigger>
            {' '} with questions.
          </div>
        </BoxFooter>
      </Box>
    );
  },

  render() {
    return (
      <div className="SchoolAdminPending">
        <SchoolAffiliationPending affiliation={this.props.affiliation}>
          {this.renderBox()}
        </SchoolAffiliationPending>
      </div>
    );
  },
});

export default SchoolAdminPending;



// WEBPACK FOOTER //
// ./src/organizations/components/SchoolAdminPending.jsx